import _sfc_main from "./Button.vue2.js";
/* empty css            */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Button = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-114c01d2"]]);
export {
  Button as default
};
//# sourceMappingURL=Button.vue.js.map
